<template>
  <div class="plate" v-if="plate">
    <div>Are you currently employed, retired, or on social disability?</div>

    <v-radio-group :error="$v.plate.key.$error" v-model="plate.key" column>
      <v-radio
        v-for="occupationItem in occupations"
        @change="handleRadiobuttonChange(occupationItem)"
        :key="occupationItem.value"
        :label="occupationItem.body"
        :value="occupationItem.key"
      />
    </v-radio-group>

    <div class="h4" v-if="plate.key">
      You're in the right place. We specialize in helping
      {{ plate.key }} find affordable coverage.
    </div>

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { required } from 'vuelidate/lib/validators';
import { PlatesSteps } from '@/common/variables';

export default {
  name: 'OccupationPlate',
  components: { PlateFooter },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.occupation
    );
    this.plate = data;
  },

  data: () => ({
    plate: null,
    isLoading: false,

    occupations: [
      {
        value: 'currentlyEmployed',
        body: 'Currently Employed',
        key: 'those in the work force',
      },
      {
        value: 'student',
        body: 'Students',
        key: 'students',
      },
      {
        value: 'stayAtHome',
        body: 'Stay at home',
        key: 'home makers',
      },
      {
        value: 'retired',
        body: 'Retired',
        key: 'retirees',
      },
      {
        value: 'unemployment',
        body: 'Unemployment',
        key: 'those unemployed',
      },
      {
        value: 'disabled',
        body: 'Disabled',
        key: 'those on disability',
      },
      {
        value: 'military',
        body: 'Military',
        key: 'in military',
      },
    ],
  }),

  computed: {
    nextPlate() {
      return this.plate.occupation.value === 'disabled'
        ? PlatesSteps.disabledAnalysis
        : PlatesSteps.analysis;
    },
  },

  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.intro);
    },
    handleRadiobuttonChange(payload) {
      this.plate.occupation = payload;
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isDisabled = this.plate.occupation.value === 'disabled';

      this.$store.commit('plates/setBranch', isDisabled);
      this.$store.commit('plates/setStep', this.nextPlate);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },

  validations: {
    plate: {
      key: {
        required,
      },
    },
  },
};
</script>

<style></style>